import { FunctionComponent, useMemo } from 'react';
import { SkeletonProps, Skeleton } from '@mui/material'


interface ISkeletonExt extends SkeletonProps {
    minWidth?: number;
    maxWidth?: number;
}

const generateRandomInteger = (min: number, max: number) => {
    return Math.floor(min + Math.random()*(max + 1 - min))
  }

const SkeletonExt: FunctionComponent<ISkeletonExt> = ({
    width, 
    maxWidth, 
    minWidth, 
    ...props
}) => {
    const calculatedWidth = useMemo(() => {
        if (width !== undefined) {
            return width;
        }

        if (minWidth !== undefined || maxWidth !== undefined) {
            return generateRandomInteger(minWidth ?? 0, maxWidth ?? (minWidth! + (minWidth! / 2)))
        }

        return undefined;
    }, [width, maxWidth, minWidth]);

    return (
        <Skeleton width={calculatedWidth} {...props} />
    );
}

export default SkeletonExt;